import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'jv',
  months: [
    'Januari',
    'Februari',
    'Maret',
    'April',
    'Mei',
    'Juni',
    'Juli',
    'Agustus',
    'September',
    'Oktober',
    'Nopember',
    'Desember',
  ],
  monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Agt', 'Sep', 'Okt', 'Nop', 'Des'],
  weekdays: ['Minggu', 'Senen', 'Selasa', 'Rebo', 'Kemis', 'Jemuwah', 'Setu'],
  weekdaysMin: ['Min', 'Sen', 'Sel', 'Re', 'Ke', 'Je', 'Se'],
  weekdaysShort: ['Ming', 'Sen', 'Sel', 'Reb', 'Kem', 'Jem', 'Set'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'HH:mm',
    lts: 'HH:mm:ss',
    L: 'DD/MM/YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY [jam] HH:mm',
    'LLL-Y': 'D MMMM HH:mm',
    LLLL: 'dddd, D MMMM YYYY [jam] HH:mm',
    'LLLL-Y': 'dddd D MMMM HH:mm',
    l: 'DD/MM/YYYY',
    'l-Y': 'DD/MM',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    'll-D': 'MMM YYYY',
    lll: 'D MMM YYYY h:mm A',
    'lll-Y': 'D MMM h:mm A',
    llll: 'ddd, D MMM YYYY h:mm A',
    'llll-Y': 'ddd, D MMM h:mm A',
    'll-Y+w': 'ddd, D MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D MMMM YYYY [jam] HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'am', pm: 'pm', AM: 'AM', PM: 'PM' },
  past: {
    y: { other: '%s taun kepungkur' },
    M: { other: '%s sasi kepungkur' },
    w: { other: '%s minggu kepungkur' },
    d: { other: '%s dina kepungkur' },
    h: { other: '%s jam kepungkur' },
    m: { other: '%s menit kepungkur' },
    s: { other: '%s detik kepungkur' },
  },
  future: {
    y: { other: 'ing %s taun' },
    M: { other: 'ing %s sasi' },
    w: { other: 'ing %s minggu' },
    d: { other: 'ing %s dina' },
    h: { other: 'ing %s jam' },
    m: { other: 'ing %s menit' },
    s: { other: 'ing %s detik' },
  },
  pastLong: {
    y: { other: '%s taun kepungkur' },
    M: { other: '%s sasi kepungkur' },
    w: { other: '%s minggu kepungkur' },
    d: { other: '%s dina kepungkur' },
    h: { other: '%s jam kepungkur' },
    m: { other: '%s menit kepungkur' },
    s: { other: '%s detik kepungkur' },
  },
  futureLong: {
    y: { other: 'ing %s taun' },
    M: { other: 'ing %s sasi' },
    w: { other: 'ing %s minggu' },
    d: { other: 'ing %s dina' },
    h: { other: 'ing %s jam' },
    m: { other: 'ing %s menit' },
    s: { other: 'ing %s detik' },
  },
  abbr: {
    y: { other: '%s tn' },
    M: { other: '%s s' },
    w: { other: '%s mgg' },
    d: { other: '%s dn' },
    h: { other: '%s j' },
    m: { other: '%s mnt' },
    s: { other: '%s dtk' },
  },
  full: {
    y: { other: '%s taun' },
    M: { other: '%s sasi' },
    w: { other: '%s minggu' },
    d: { other: '%s dina' },
    h: { other: '%s jam' },
    m: { other: '%s menit' },
    s: { other: '%s detik' },
  },
  justNow: 'lagi wae',
  yesterday: 'Wingi',
  today: 'Dina Iki',
  tomorrow: 'Sesuk',
  weekStart: 0,
  timeRange: '%$1s – %$2s',
  timeZone: '%$1s %$2s',
  timePref: { 'h:mm A': 'HH:mm' },
  timeRangeStyles: {
    yl: { start: 'D MMMM YYYY', end: 'D MMMM YYYY' },
    'yl-1': { start: 'D MMMM', end: 'D MMMM YYYY' },
    ml: { start: 'D MMMM', end: 'D MMMM' },
    'ml-1': { start: 'D', end: 'D MMMM YYYY' },
    dl: { start: 'D', end: 'D MMMM' },
    y: { start: 'D MMM YYYY', end: 'D MMM YYYY' },
    'y-1': { start: 'D MMM', end: 'D MMM YYYY' },
    m: { start: 'D MMM', end: 'D MMM' },
    'm-1': { start: 'D', end: 'D MMM YYYY' },
    d: { start: 'D MMM', end: 'D MMM' },
    Y: { start: 'ddd, D MMM YYYY', end: 'ddd, D MMM YYYY' },
    'Y-1': { start: 'ddd, D MMM', end: 'ddd, D MMM YYYY' },
    M: { start: 'ddd, D MMM', end: 'ddd, D MMM' },
    D: { start: 'ddd, D MMM', end: 'ddd, D MMM' },
    yt: { start: 'D MMM YYYY HH:mm', end: 'D MMM YYYY HH:mm' },
    mt: { start: 'D MMM HH:mm', end: 'D MMM HH:mm' },
    dt: { start: 'D MMM HH:mm', end: 'D MMM HH:mm' },
    t: { start: 'HH:mm', end: 'HH:mm' },
    'yt+to': { start: 'D MMM YYYY HH:mm', end: 'D MMM YYYY HH:mm ([GMT]Z)' },
    'mt+to': { start: 'D MMM HH:mm', end: 'D MMM HH:mm ([GMT]Z)' },
    'dt+to': { start: 'D MMM HH:mm', end: 'D MMM HH:mm ([GMT]Z)' },
    't+to': { start: 'HH:mm', end: 'HH:mm ([GMT]Z)' },
  },
};
const localeName: LocaleName = 'jv';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'am' : 'AM';
    } else {
      return isLowerCase ? 'pm' : 'PM';
    }
  },
};
